import { render, staticRenderFns } from "./SegmentedChoice.vue?vue&type=template&id=05d12732"
import script from "./SegmentedChoice.vue?vue&type=script&lang=js"
export * from "./SegmentedChoice.vue?vue&type=script&lang=js"
import style0 from "./SegmentedChoice.vue?vue&type=style&index=0&id=05d12732&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports